<script setup lang="ts">
import { ref } from "vue"
import { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from "~/components/ui/drawer"
import { ScrollArea } from "~/components/ui/scroll-area"
import HiddenChannelsList from "~/components/voice-ui/Channels/HiddenChannelsList.vue"
import { useHiddenChannelsDrawer } from "~/composables/useHiddenChannelsDrawer"
import { useMobileDrawerBackNav } from "~/composables/useMobileDrawerBackNav"
import { usePlatform } from "~/composables/usePlatform"

const { isMobile } = usePlatform()
const { isOpen, groupId } = useHiddenChannelsDrawer()

useMobileDrawerBackNav({ isOpen, screen: ref<"list" | "detail">("list"), enabled: isMobile })
</script>

<template>
  <Drawer v-model:open="isOpen">
    <DrawerContent class="flex max-h-[94vh] flex-col gap-0 p-0" data-testid="hidden-channels-drawer">
      <DrawerHeader class="items-center text-center">
        <DrawerTitle>Скрытые каналы</DrawerTitle>
        <DrawerDescription>Скрыты только на этом устройстве</DrawerDescription>
      </DrawerHeader>
      <ScrollArea class="min-h-0 flex-1">
        <div class="pb-[calc(env(safe-area-inset-bottom,0px)+1.5rem)]">
          <HiddenChannelsList v-if="groupId" :group-id="groupId"/>
        </div>
      </ScrollArea>
    </DrawerContent>
  </Drawer>
</template>
